// Deck Configuration - Defines all available decks and their properties

export const DECKS = {
  characters: {
    id: 'characters',
    name: 'Characters',
    nameCN: '汉字',
    icon: '字',
    color: '#22c55e',        // Green (matches T1-T6 system)
    description: 'Most frequent Chinese characters',
    weighted: true,          // Uses frequency-based weighting
    freeLimit: 150,          // First 150 for free users
    blendWithCustom: true,   // Custom cards mix into this deck
  },
  radicals: {
    id: 'radicals',
    name: 'Radicals',
    nameCN: '部首',
    icon: '部',
    color: '#3b82f6',        // Blue
    description: 'Building blocks of Chinese characters',
    weighted: false,
    copies: 2,               // Equal distribution (2 copies each)
    // No free limit: the full radicals deck is free. Radicals are the beginner
    // on-ramp and have always been advertised as free in full.
    blendWithCustom: false,
  },
  bigrams: {
    id: 'bigrams',
    name: 'Words',
    nameCN: '词语',
    icon: '词',
    color: '#8b5cf6',        // Purple
    description: 'Common two-character words',
    weighted: false,
    copies: 3,
    freePercent: 0.15,
    blendWithCustom: false,
  },
  verbs: {
    id: 'verbs',
    name: 'Verbs',
    nameCN: '动词',
    icon: '动',
    color: '#f97316',        // Orange
    description: 'Essential action words',
    weighted: false,
    copies: 3,
    freePercent: 0.15,
    blendWithCustom: false,
  },
  connectors: {
    id: 'connectors',
    name: 'Phrases',
    nameCN: '口语',
    icon: '话',
    color: '#ec4899',        // Pink
    description: 'Conversational phrases and expressions',
    weighted: false,
    copies: 2,
    freePercent: 0.15,
    blendWithCustom: false,
  },
  custom: {
    id: 'custom',
    name: 'Custom',
    nameCN: '自定义',
    icon: '我',
    color: '#FFD700',        // Gold
    description: 'Your personal flashcards',
    weighted: false,
    copies: 3,
    freeLimit: 10,           // Max 10 cards for free users
    requiresAuth: true,
    requiresPro: false,      // Can add up to 10 free
    blendWithCustom: false,  // This IS the custom deck
  },
};

// Badge text shown on cards for each deck type
export const getDeckBadge = (deckId, originalIndex) => {
  if (deckId === 'characters') {
    // Use frequency tier system for characters
    if (originalIndex < 100) return { label: 'T1', color: '#22c55e', desc: '核心' };
    if (originalIndex < 200) return { label: 'T2', color: '#84cc16', desc: '高频' };
    if (originalIndex < 300) return { label: 'T3', color: '#eab308', desc: '常用' };
    if (originalIndex < 500) return { label: 'T4', color: '#f97316', desc: '中频' };
    if (originalIndex < 700) return { label: 'T5', color: '#ef4444', desc: '扩展' };
    return { label: 'T6', color: '#a855f7', desc: '进阶' };
  }

  const deck = DECKS[deckId];
  if (!deck) return { label: '?', color: '#888', desc: '' };

  return {
    label: deck.icon,
    color: deck.color,
    desc: deck.nameCN,
  };
};

// Get deck by ID
export const getDeck = (deckId) => DECKS[deckId] || null;

// Get all deck IDs
export const getAllDeckIds = () => Object.keys(DECKS);

// Get decks available to a user based on their subscription status
export const getAvailableDecks = (isPro, isAuthenticated) => {
  return Object.values(DECKS).filter(deck => {
    if (deck.requiresAuth && !isAuthenticated) return false;
    return true;
  });
};
